export const maxFileSize = 10000000;


// WEBPACK FOOTER //
// ./src/prefs.js